<template>
  <div
    class="home">
    <!--<ljb-header-->
    <!--:title="title"-->
    <!--:back-arrow="BackArrow"/>-->
    <swipe-banner @onClick="onBannerClick"/>
    <div class="consult">
      <!-- <module-title :module-title = "moduleTitle"/> -->
      <list-field/>
    </div>
    <!-- <common-problems/> -->
    <dynamic-list/>
    <div class="linege" />
    <list-serivce/>
    <!-- <card-list/> -->
    <div class="linege" />
    <list-lawyer />
    <div class="linege" />
    <list-information />
    <div class="bottom-banner">
      <img src="https://cdn.51ljb.cn/bottom_banner.png">
    </div>
    <!-- <div class="fixed-mylawyer" @click="goLawyer">
      <img src="https://cdn.51ljb.cn/ljb_icons_home_mylawyer.png">
    </div> -->
    <popup-coupon
      :show-coupon="isShowCoupon"
      :coupon-img = "couponImg"
      @getCoupon="getCouponState"
      @closeCoupon="closeCoupon"/>
    <cooperation-logo v-show="showLogo"/>
    <ljb-footer/>
  </div>

</template>

<script>
import SwipeBanner from '@/components/swiper/SwipeBannerNew'
import ModuleTitle from '@/components/title/ModuleTitle'
import ListField from '@/components/list/ListField'
import ListSerivce from '@/components/list/ListServiceNew'
import ListLawyer from '@/components/list/ListLawyer'
import ListInformation from '@/components/list/ListInformation'
import SwipeActive from '@/components/swiper/SwipeActive'
import LjbFooter from '@/components/common/LjbFooter'
import LjbHeader from '@/components/LjbHeader'
import DynamicList from '@/components/views/DynamicList'
import PopupConsulting from '@/components/popup/consulting/PopupConsulting'
import {mapGetters} from 'vuex'
import PopupCoupon from '@/components/popup/PopupCoupon'
import CardItems from '../components/views/CardItems'
import CardList from '../components/views/CardList'
import CooperationLogo from '@/components/views/CooperationLogo'
import CommonProblems from '../components/views/CommonProblems'
export default {
  name: 'Home',
  components: {
    CommonProblems,
    CooperationLogo,
    CardItems,
    CardList,
    PopupCoupon,
    PopupConsulting,
    DynamicList,
    LjbHeader,
    LjbFooter,
    SwipeActive,
    ListSerivce,
    ListField,
    ModuleTitle,
    ListLawyer,
    ListInformation,
    SwipeBanner},
  data () {
    return {
      title: '律家保-您的私人律师',
      BackArrow: true,
      currentIndex: '0',
      isShowCzh: true, // 是否显示车智慧图标
      showPopup: true,
      popupInfo: {
        title: '导出成功',
        text: '您将在3个工作日内收到',
        subText: '请耐心等待'
      },
      moduleTitle: {
        title: '选择领域 点击咨询',
        text: ''
      },
      isShowAlert: false,
      isShowCoupon: false,
      couponImg: '',
      popupConsult: {
        title: '交通出行',
        text: '10元/分钟',
        typeList: [{
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }]
      }

    }
  },
  computed: {
    ...mapGetters('User', ['getUserInfo', 'getShowLogin', 'getCoupon']),
    showCoupon () {
      let userInfo = this.getUserInfo
      let isShow = true
      if (userInfo) {
        isShow = userInfo.showCoupon > 0
      }
      if (this.getShowLogin) {
        isShow = false
      }
      if (this.$utils.getChannel() !== 'czh') {
        isShow = false
      }
      return isShow
    },
    showLogo () {
      let isShow = false
      if (this.$utils.getChannel() === 'czh') {
        isShow = true
      }
      return isShow
    }
  },
  watch: {
    getUserInfo () {
      if (this.getCoupon && this.getUserInfo) {
        this.getCouponAction()
      }
    }
  },
  mounted () {
    this.couponShow()
    this.$utils.clearOrderInfo()
  },
  methods: {
    check () {
      this.isShowAlert = true
    },
    // 点击获取优惠券
    getCouponState () {
      if (!this.getUserInfo) {
        this.$store.commit('User/setShowLogin', true)
        this.isShowCoupon = false
        this.$store.commit('User/setCoupon', true)
        return
      }
      this.getCouponAction()
    },

    // 调用接口获取优惠券
    getCouponAction () {
      this.$post.getActive().then(res => {
        this.$toast(res.msg)
        this.isShowCoupon = false
        setTimeout(() => {
          this.$router.push('coupon')
        }, 1500)
        this.$store.commit('User/setCoupon', null)
      }).catch(res => {
        this.$router.push('coupon')
      })
    },

    // 是否显示优惠券
    couponShow () {
      this.$post.whichActive().then(res => {
        if (res.data) {
          if (res.data.img) {
            this.couponImg = res.data.img
            this.isShowCoupon = true
          }
        }
      })
    },
    closeCoupon () {
      this.isShowCoupon = false
    },
    onBannerClick (item) {
      if (item && item.url === 'show_coupon') {
        this.getCouponState()
      }
    },
    goLawyer() {
      this.$router.push('Lawyer')
    }
  }
}
</script>

<style lang="scss" scoped>
  .consult{
    background: #fff;
  }
  .home{
    background: #fff;
    padding-bottom: 60px;
    overflow: hidden;
  }
  .linege{
    width: 100%;
    height: 8px;
    background: #f7f7f7;
  }
  .bottom-banner{
    padding:0 $padding;
    box-sizing: border-box;
    width: 100%;
    height: 140px;
    >img{
      width: 100%;
      height: 100%;
    }
  }
  .fixed-mylawyer{
    position: fixed;
    right: 10px;
    bottom: 56px;
    >img{
      width: 64px;
      height: 88px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue